const SearchEntity = () => {
    return null;
};

export default SearchEntity;
